<template>
    <div ref="popover" id="popover" v-click-outside="closePopover" v-on:click.stop>
 
       <div>
          <ColorPicker v-model:pure-color="colorCode"
             is-widget
             format="hex"
             use-type="pure"
             disable-history
             disable-alpha
             lang="En"
             @update:pureColor="onColorPickerChange">
                <template v-slot:extra>
                   <div class="text-end">
                      <button type="button" class="btn btn-sm btn-info text-light me-2" @click="updateColor($event)">Select Color</button>
                      <button type="button" class="btn btn-sm btn-warning text-light" @click="resetColorPicker($event)">Cancel</button>
                   </div>
                </template>
          </ColorPicker>
       </div>
    </div>
 </template>
 
 <script>
 import { Popover } from 'bootstrap';
 import { ColorPicker } from "vue3-colorpicker";
 import "vue3-colorpicker/style.css";
 import "@/assets/css/vue3-colorpicker.css";
 
 export default ({
 
    components: { 
       ColorPicker,
     },
 
    emits: ['onColorChange'],
 
    // props: {
    //    color: {
    //       type: String
    //    },
    //    shape: {
    //       type: String
    //    }
    // },
 
    data(){
       return {
          color: "",
          shape: "",
          colorCode: "",
          colorValue: "",
       }
       
    },
 
    // created() {
    //    this.init()
    // },
    
 
    // mounted(){
    //    this.init()
    // },
 
    methods: {
 
       async init() {
          this._originalColor = this.color //save original color
          this.colorCode = this.color
       },
 
       onColorPickerChange(color) {
          this.colorValue = color
       },
 
       updateColor(e) {
          this.$emit("onColorChange", this.colorValue)
          this.closePopover(e)
       },
 
       resetColorPicker(e) {
          // reset to original color 
          this.colorCode = this._originalColor
          this.closePopover(e)
       },
 
       async showPopover(e, color, shape) {
          this.color = color
          this.shape = shape
          this.init()
 
          let opts = {
             placement: "bottom",
             sanitize: false,
             html: true,
             customClass: 'color-picker-popover',
             trigger: "manual",
             content: this.$refs.popover,
          }
 
          //close all open popovers first
          // this.closePopover(e)
 
          // if in case user double clicked the same element, hide the popover first
          if (Popover.getInstance(e) != null){
             Popover.getInstance(e).dispose()
          } else {
             setTimeout(()=>{
                Popover.getOrCreateInstance(e, opts).show()
             },100);
          }
 
       },
 
       closePopover(e){
          var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
 
          popoverTriggerList.map((el) => {
             if (el != e.target && Popover.getInstance(el) != null){
                Popover.getInstance(el).dispose()
             }
          })
       },
 
       
    },
 
 })
 </script>
 
 <style scoped>
 </style>